export enum ApplicationSizeUnit {
    Unknown = "Unknown",
    KG = "KG",
    Single = "Single",
}
